import { FormattedMessage } from 'react-intl'
import { DiscountType, Restrictions } from 'typings'
import { SummaryRow, Tag, TagsList } from 'ui'
import { messages } from '../messages'

type Props = {
  restrictions: Partial<
    Pick<Restrictions, 'accumulate' | 'accumulateWithManualPrices'>
  >
  discountType?: DiscountType
}

export function AccumulateRow(props: Props) {
  const {
    restrictions: { accumulate, accumulateWithManualPrices },
    discountType,
  } = props

  return (
    <SummaryRow>
      <SummaryRow.Title>
        <FormattedMessage {...messages.accumulate.title} />
      </SummaryRow.Title>
      <SummaryRow.Value>
        <TagsList>
          <Tag>
            <FormattedMessage
              {...messages.accumulate.otherPromotions}
              values={{ accumulate, discountType }}
            />
          </Tag>
          {accumulateWithManualPrices && (
            <Tag>
              <FormattedMessage {...messages.accumulate.manualPrice} />
            </Tag>
          )}
        </TagsList>
      </SummaryRow.Value>
    </SummaryRow>
  )
}
